module.exports = __webpack_public_path__ + "static/media/conference_34.bce09387.jpg";